import React from "react";

import PageHeader from "Components/Pages/Header";
import PageWrapper from "Components/Pages/Wrapper";
import { Pagination } from "Components/Pagination";
import Breadcrumb from "Components/Shared/Breadcrumb";

import moment from "moment";

import { PrePreOrderList } from "./components/PrePreOrderList";
import { ContentHolder } from "./styles";
import "react-dates/lib/css/_datepicker.css";
import "moment/locale/pt-br";
import { PrePreOrderFilters } from "./components/PrePreOrderFilters";
import { usePrePreOrderListUnit } from "./usePrePreOrderListUnit";

moment.locale("pt-br");

const PrePreOrderListUnit = () => {
  const { prePreOrderList, setNewPage, setFilters, handlePagination } =
    usePrePreOrderListUnit();

  const totalItems = prePreOrderList?.data?.total || 0;
  const hasMultiplePages =
    !prePreOrderList.isLoading &&
    prePreOrderList.data?.last_page &&
    prePreOrderList.data.last_page > 1;

  return (
    <PageWrapper className="entry-app-content">
      <ContentHolder className="content-holder ">
        <div className="page-heading order-home-list">
          <div className="wrapper-header-content">
            <PageHeader title="Listagem de pré-pedidos" className="lg-12">
              <Breadcrumb
                list={[
                  {
                    path: "#",
                    label: "Listagem de pré-pedidos",
                    current: true,
                  },
                ]}
              />
            </PageHeader>
          </div>

          <PrePreOrderFilters
            setFilters={setFilters}
            itemsQuantity={totalItems}
            setNewPage={setNewPage}
          />
        </div>

        <div className="content-list">
          <PrePreOrderList
            items={prePreOrderList?.data?.data}
            loading={prePreOrderList.isLoading}
          />
        </div>
      </ContentHolder>

      {hasMultiplePages && (
        <div className="pagination-wrapper">
          <Pagination
            totalRecords={prePreOrderList?.data?.last_page}
            currentPageSelected={prePreOrderList?.data?.current_page}
            pageLimit={1}
            pageNeighbours={1}
            onPageChanged={(event) => handlePagination(event)}
          />
        </div>
      )}
    </PageWrapper>
  );
};

export default PrePreOrderListUnit;
